import { useContext, useEffect, useState, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@chakra-ui/react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import WorkFlowFormModalForeign from "./WorkFlowFormModalForeign";
import { workFlowInitialValues } from "./utils/constant";
import { generateApprovalsArray, updateWorkFlowInitialValues } from "./utils/function";
import { replaceLabelValueObjects } from "utils/functions/function";

const AddFormForeign = ({ handleGetData }: any) => {
  const { toastNotify, getUsersWorkFlows } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // Set hardcoded defaults for foreign workflow
  const baseValues = updateWorkFlowInitialValues(workFlowInitialValues);
  const [initialVal, setInitialVal] = useState({
    ...baseValues,
    processName: { label: "foreign", value: "foreign" },
    processType: { label: "NonPo", value: "NonPo" },
    levels: 7,
  });

  // Generate initial levels for 7 levels
  useEffect(() => {
    const dummySetFieldValue = (field: string, value: any) => {
      setInitialVal((prev: any) => ({ ...prev, [field]: value }));
    };
    generateApprovalsArray(dummySetFieldValue, initialVal, 7);
  }, []);

  const submitForm = async (values: any, resetForm: any) => {
    try {
      setLoading(true);
      if (values) {
        const dataArray = Array.isArray(values) ? values : [values];
        let successCount = 0;
        let errors = [];

        for (const item of dataArray) {
          const payload = {
            ...replaceLabelValueObjects(item),
            processName: item.processName?.value || (Array.isArray(item.processName) ? item.processName[0] : item.processName),
            processType: item.processType?.value || (Array.isArray(item.processType) ? item.processType[0] : item.processType),
            regions: item.regions?.value || (Array.isArray(item.regions) ? item.regions[0] : item.regions),
          };

          const response: any = await appRequest("workflow", "create", payload);
          if (response.status === "success") {
            successCount++;
          } else {
            errors.push(response.message || `Failed to create workflow for region: ${payload.regions}`);
          }
        }

        if (successCount > 0) {
          toastNotify({
            title: `Success`,
            message: `${successCount} Foreign Workflow(s) created successfully`,
            type: "success"
          });
          handleGetData();
          getUsersWorkFlows();
          resetForm();
          handleCloseModal();
        }

        if (errors.length > 0) {
          toastNotify({
            title: `Errors encountered during creation`,
            message: errors.join(", "),
            type: "error",
          });
        }
      }
    } catch (err: any) {
      console.log(err)
      toastNotify({
        title: `Technical error during creation`,
        message: err.message || "Something went wrong.",
        type: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = () => {
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
    setLoading(false);
  };

  const memoizedInitialValues = useMemo(() => ({
    ...initialVal,
    identifier: uuidv4()
  }), [isOpen]); // Only change ID when modal opens

  return (
    <>
      <div>
        <Button
          color="white"
          w={{ base: "5rem", lg: "8rem" }}
          _hover={{
            bg: "teal.400",
          }}
          bg="teal.300"
          fontSize={{ base: "xs", lg: "sm" }}
          onClick={() => handleOpenModal()}
        >
          Add Foreign Workflow
        </Button>
      </div>
      <WorkFlowFormModalForeign
        type="create"
        isOpen={isOpen}
        onClose={handleCloseModal}
        initialValues={memoizedInitialValues}
        loading={loading}
        submitForm={submitForm}
        showError={showError}
        setShowError={setShowError}
      />
    </>
  );
};

export default AddFormForeign;
